import { useRef, useState } from "react";

// Runs one async action at a time: a call while one runs is ignored. A busy state alone can't do this, since
// it only changes after the next render, so a quick second click would still start the action again.
export const useSingleFlight = () => {
  const running = useRef(false);
  const [isRunning, setIsRunning] = useState(false);

  const run = async (action: () => Promise<void>) => {
    if (running.current) return;
    running.current = true;
    setIsRunning(true);
    try {
      await action();
    } finally {
      running.current = false;
      setIsRunning(false);
    }
  };

  return { run, isRunning };
};
